import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import WarningIcon from '@material-ui/icons/Warning'
import styles from './ImproveBox.icss'

class ImproveBox extends React.Component {
	render() {
		const { children, className, text, ...rest } = this.props
		return (
			<div className={classnames(styles.improveSurround, className)} {...rest}>
				<div className={styles.header}>
					<span className={styles.icon}>
						<WarningIcon />
					</span>
					<span className={styles.text}>
						{text}
					</span>
				</div>
				<span className={styles.content}>{children && children}</span>
			</div>
		)
	}
}

ImproveBox.propTypes = {
	children: PropTypes.node,
	text: PropTypes.string,
	className: PropTypes.string
}

ImproveBox.defaultProps = {
	children: undefined,
	text: undefined,
	className: undefined
}

export default ImproveBox



// WEBPACK FOOTER //
// ./src/components/ImproveBox.jsx